/* eslint-disable */
import Layout from '@/layout/index.vue';

const routes = {
  // 浏览记录
  BrowsingHistory: () => import(/* webpackChunkName: "BrowsingHistory" */ '@/views/page/BrowsingHistory/index')
};

export const BrowsingHistory = [
  {
    path: '/BrowsingHistory',
    isMenu: true,
    component: Layout,
    redirect: { name: 'BrowsingHistory' },
    children: [
      {
        path: 'index',
        name: 'BrowsingHistory',
        component: routes['BrowsingHistory'],
        meta: { title: '官网浏览记录', icon: 'menu_baseSetting'}
      }
    ]
  }
];
